import { ViewStream } from 'spyne';
import { AppLocalStorageTraits} from 'traits/app-local-storage-traits.js';

export class LocalStorage extends ViewStream {
  constructor(props = {}) {
    props.channels = ["CHANNEL_LOCAL_STORAGE"];
    props.traits = [AppLocalStorageTraits];
    super(props);
  }

  addActionListeners() {
    return [];
  }

  broadcastEvents() {
    return [];
  }

  onRendered() {

    this.localStorage$InitAppSettings();
/*    console.log('local storage null view');
    this.sendInfoToChannel("CHANNEL_LOCAL_STORAGE", {test:"ubu"}, "CHANNEL_LOCAL_STORAGE_UPDATE_KEY_REQUEST")*/

  }
}
